!function ($) {
  "use strict";
  //     document ready start 🚩
  $(document).ready(function () {
    $(document).on("click", ".tab-btn", function () {
      const $tabGroup = $(this).closest(".tab-switcher");
      const $contentContainer = $tabGroup.next(".tab-content");
      const tabIndex = $(this).index();

      // Pause any playing videos inside all tab items
      $contentContainer.find("video").each(function () {
        this.pause();
      });

      // Switch active state
      $tabGroup
        .find(".tab-btn")
        .removeClass("active")
        .eq(tabIndex)
        .addClass("active");

      $contentContainer
        .find(".tab-item")
        .removeClass("active")
        .eq(tabIndex)
        .addClass("active");
    });

    $(".hero-slide").slick({
      dots: true,
      arrows: true,
      infinite: true,
      speed: 600,
      slidesToShow: 1,
      autoplay: true,
      slidesToScroll: 1,
      autoplaySpeed: 5000,
      autoplay: true,
      prevArrow: `
      <div class="slick-prev" aria-label="Previous">
        <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M26.985 0C41.9291 0 54 12.0622 54 27C54 41.9395 41.9273 54 26.985 54C12.0532 54 0 41.8952 0 27C0 12.0727 12.0727 0 26.985 0ZM50.4904 27C50.4993 14.0602 39.9935 3.53145 27.0505 3.50841C14.0721 3.48536 3.54687 13.9751 3.50965 26.9628C3.47597 39.9203 14.0154 50.4845 26.9779 50.4898C39.9581 50.4969 50.4833 39.9859 50.4904 27Z" fill="#186FBB"/>
          <path d="M22.2616 26.7384C24.5792 26.7384 26.8018 25.8178 28.4406 24.179C30.0793 22.5402 31 20.3176 31 18" stroke="#186FBB" stroke-width="3" stroke-linecap="square"/>
          <path d="M22.2616 26.7383C24.5792 26.7383 26.8018 27.6589 28.4406 29.2977C30.0793 30.9365 31 33.1591 31 35.4767" stroke="#186FBB" stroke-width="3" stroke-linecap="square"/>
        </svg>
      </div>
    `,
      nextArrow: `
      <div class="slick-next" aria-label="Next">
        <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M27.015 0C12.0709 0 0 12.0622 0 27C0 41.9395 12.0727 54 27.015 54C41.9468 54 54 41.8952 54 27C54 12.0727 41.9273 0 27.015 0ZM3.5096 27C3.50074 14.0602 14.0065 3.53145 26.9495 3.50841C39.9279 3.48536 50.4531 13.9751 50.4904 26.9628C50.524 39.9203 39.9846 50.4845 27.0221 50.4898C14.0419 50.4969 3.51669 39.9859 3.5096 27Z" fill="#186FBB"/>
          <path d="M31.7384 26.7384C29.4208 26.7384 27.1982 25.8178 25.5594 24.179C23.9207 22.5402 23 20.3176 23 18" stroke="#186FBB" stroke-width="3" stroke-linecap="square"/>
          <path d="M31.7384 26.7383C29.4208 26.7383 27.1982 27.6589 25.5594 29.2977C23.9207 30.9365 23 33.1591 23 35.4767" stroke="#186FBB" stroke-width="3" stroke-linecap="square"/>
        </svg>
      </div>
    `,
    });

    $(".testimonial-cards").slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      infinite: false,

      responsive: [
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
          },
        },
      ],
    });

    $(".main-image").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: false,
      infinite: false,
      speed: 1000,
      asNavFor: ".thumbnails-container",
      prevArrow:
        '<button class="slider-btn prev">' +
        '<svg width="12" height="22" viewBox="0 0 12 22" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M0.999829 11.0002C3.65204 11.0002 6.19562 9.94658 8.07102 8.07119C9.94641 6.19579 11 3.65221 11 1" stroke="white" stroke-width="2" stroke-linecap="square"/>' +
        '<path d="M0.999829 11C3.65204 11 6.19562 12.0536 8.07102 13.929C9.94641 15.8044 11 18.348 11 21.0002" stroke="white" stroke-width="2" stroke-linecap="square"/>' +
        "</svg>" +
        "</button>",
      nextArrow:
        '<button class="slider-btn next">' +
        '<svg width="12" height="22" viewBox="0 0 12 22" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M11.0002 11.0002C8.34796 11.0002 5.80438 9.94658 3.92898 8.07119C2.05359 6.19579 1 3.65221 1 1" stroke="white" stroke-width="2" stroke-linecap="square"/>' +
        '<path d="M11.0002 11C8.34796 11 5.80438 12.0536 3.92898 13.929C2.05359 15.8044 1 18.348 1 21.0002" stroke="white" stroke-width="2" stroke-linecap="square"/>' +
        "</svg>" +
        "</button>",
    });

    $(".thumbnails-container").slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: ".main-image",
      dots: false,
      centerMode: false,
      focusOnSelect: true,
      infinite: false,
    });

    $(".our-expert").slick({
      slidesToShow: 5,
      slidesToScroll: 5,
      arrows: false,
      dots: true,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 3000,
      speed: 800,
      responsive: [
        {
          breakpoint: 1299,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
          },
        },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 1,
            dots: false,
            arrows: true,
            slidesToScroll: 1,
            prevArrow: `
      <div class="slick-prev" aria-label="Previous">
        <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M26.985 0C41.9291 0 54 12.0622 54 27C54 41.9395 41.9273 54 26.985 54C12.0532 54 0 41.8952 0 27C0 12.0727 12.0727 0 26.985 0ZM50.4904 27C50.4993 14.0602 39.9935 3.53145 27.0505 3.50841C14.0721 3.48536 3.54687 13.9751 3.50965 26.9628C3.47597 39.9203 14.0154 50.4845 26.9779 50.4898C39.9581 50.4969 50.4833 39.9859 50.4904 27Z" fill="#186FBB"/>
          <path d="M22.2616 26.7384C24.5792 26.7384 26.8018 25.8178 28.4406 24.179C30.0793 22.5402 31 20.3176 31 18" stroke="#186FBB" stroke-width="3" stroke-linecap="square"/>
          <path d="M22.2616 26.7383C24.5792 26.7383 26.8018 27.6589 28.4406 29.2977C30.0793 30.9365 31 33.1591 31 35.4767" stroke="#186FBB" stroke-width="3" stroke-linecap="square"/>
        </svg>
      </div>
    `,
            nextArrow: `
      <div class="slick-next" aria-label="Next">
        <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M27.015 0C12.0709 0 0 12.0622 0 27C0 41.9395 12.0727 54 27.015 54C41.9468 54 54 41.8952 54 27C54 12.0727 41.9273 0 27.015 0ZM3.5096 27C3.50074 14.0602 14.0065 3.53145 26.9495 3.50841C39.9279 3.48536 50.4531 13.9751 50.4904 26.9628C50.524 39.9203 39.9846 50.4845 27.0221 50.4898C14.0419 50.4969 3.51669 39.9859 3.5096 27Z" fill="#186FBB"/>
          <path d="M31.7384 26.7384C29.4208 26.7384 27.1982 25.8178 25.5594 24.179C23.9207 22.5402 23 20.3176 23 18" stroke="#186FBB" stroke-width="3" stroke-linecap="square"/>
          <path d="M31.7384 26.7383C29.4208 26.7383 27.1982 27.6589 25.5594 29.2977C23.9207 30.9365 23 33.1591 23 35.4767" stroke="#186FBB" stroke-width="3" stroke-linecap="square"/>
        </svg>
      </div>
    `,
          },
        },
      ],
    });

    const $cards = $(".feature-section-card");
    const $container = $(".features-section-grid");
    if ($(window).width() > 640) {
      $cards.on("mouseenter", function () {
        $cards.removeClass("active");
        $(this).addClass("active");
      });

      // Optional: Reset to default on mouse leave
      $container.on("mouseleave", function () {
        $cards.removeClass("active");
        $cards.eq(0).addClass("active"); // Set the first card as default
      });
    } else {
      $cards.eq(0).removeClass("active");
    }

    if ($(window).width() < 640) {
      if (!$(".products-grid").hasClass("slick-initialized")) {
        $(".products-grid").slick({
          slidesToShow: 1.2,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          infinite: false,
        });
      } else {
        if ($(".products-grid").hasClass("slick-initialized")) {
          $(".products-grid").slick("unslick");
        }
      }

      $(document).on("click", ".item.has-submenu > a", function (e) {
        e.preventDefault();

        const $item = $(this).closest(".item");
        const $submenu = $item.find(".submenu").first();

        // Close all other open submenus
        $(".item.has-submenu")
          .not($item)
          .removeClass("active")
          .find(".submenu")
          .removeClass("open");

        // Toggle current submenu and active state
        $item.toggleClass("active");
        $submenu.toggleClass("open");
      });

      if (!$(".features-grid").hasClass("slick-initialized")) {
        $(".features-grid").slick({
          slidesToShow: 1.4,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          infinite: false,
        });
      } else {
        if ($(".features-grid").hasClass("slick-initialized")) {
          $(".features-grid").slick("unslick");
        }
      }

      // if (!$(".testimonial-cards").hasClass("slick-initialized")) {
      //   $(".testimonial-cards").slick({
      //     slidesToShow: 1,
      //     slidesToScroll: 1,
      //     arrows: false,
      //     dots: true,
      //     infinite: false,
      //   });
      // } else {
      //   if ($(".testimonial-cards").hasClass("slick-initialized")) {
      //     $(".testimonial-cards").slick("unslick");
      //   }
      // }
    }

    $(".faq-item .faq-question").click(function () {
      let parent = $(this).parent();
      $(".faq-item").removeClass("active");
      $(".faq-item .faq-answer").slideUp();
      $(".faq-item .faq-question span").text("+");

      if (!parent.hasClass("active")) {
        parent.addClass("active");
        parent.find(".faq-answer").slideDown();
        parent.find(".faq-question span").text("-");
      }
    });

    $(".menu").click(function () {
      $(this).toggleClass("cross-menu");
      // slide from left
      $(".mobile-nav").slideToggle();
      $("body").toggleClass("overflow-hidden");
    });

    // quantity add to cart funct.
    var variantCurrentId;
    var currentQuantity = 1;

    var QtyInput = (function () {
      var $qtyInputs = $(".qty-input");

      if (!$qtyInputs.length) {
        return;
      }

      var $inputs = $qtyInputs.find(".product-qty");
      var $countBtn = $qtyInputs.find(".qty-count");
      var qtyMin = parseInt($inputs.attr("min"));
      var qtyMax = parseInt($inputs.attr("max"));

      $inputs.change(function () {
        var $this = $(this);
        var $minusBtn = $this.siblings(".qty-count--minus");
        var $addBtn = $this.siblings(".qty-count--add");
        var qty = parseInt($this.val());
        currentQuantity = qty;
        if (isNaN(qty) || qty <= qtyMin) {
          $this.val(qtyMin);
          $minusBtn.attr("disabled", true);
        } else {
          $minusBtn.attr("disabled", false);

          if (qty >= qtyMax) {
            $this.val(qtyMax);
            $addBtn.attr("disabled", true);
          } else {
            $this.val(qty);
            $addBtn.attr("disabled", false);
          }
        }
      });

      $countBtn.click(function () {
        var operator = this.dataset.action;
        var $this = $(this);
        var $input = $this.siblings(".product-qty");
        var qty = parseInt($input.val());

        if (operator == "add") {
          qty += 1;
          if (qty >= qtyMin + 1) {
            $this.siblings(".qty-count--minus").attr("disabled", false);
          }

          if (qty >= qtyMax) {
            $this.attr("disabled", true);
          }
        } else {
          qty = qty <= qtyMin ? qtyMin : (qty -= 1);

          if (qty == qtyMin) {
            $this.attr("disabled", true);
          }

          if (qty < qtyMax) {
            $this.siblings(".qty-count--add").attr("disabled", false);
          }
        }

        $input.val(qty);
        currentQuantity = qty;
      });
    })();

    $(document).on("click", ".addToCart", function (event) {
      event.preventDefault();

      let variantId =
        variantCurrentId === undefined
          ? $(this).data("variant-id")
          : variantCurrentId;

      console.log("Variant ID:", variantId);

      var item = {
        id: variantId,
        quantity: currentQuantity,
      };

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
        body: JSON.stringify(item),
      })
        .then((res) => res.json())
        .then(function (addedItem) {
          console.log("🟩 Updated Cart Item:", addedItem);

          // ⭐ GET LAST ADDED PRODUCT HANDLE (NO HTML CHANGE REQUIRED)
          if (addedItem && addedItem.handle) {
            lastAddedProductHandle = addedItem.handle;
            localStorage.setItem("last_added_handle", addedItem.handle);

            console.log("🟦 Last Added Handle Set:", addedItem.handle);

            loadRelatedProductsDynamic();
          } else {
            console.warn("❌ No handle found in add.js response!");
          }

          if (!$(event.target).hasClass("buyNow-btn")) {
            dropdowncart();
            $("#cart_drawer").addClass("active");
            return;
          } else {
            openRzpCheckout(event);
          }
        })
        .catch((error) => console.error("Error:", error));
    });

    $(document).on("click", ".buy-now", function () {
      const variantId = $(this).data("variant-id");
      let qty = $(".quantity-container .product-qty").val();

      console.log(qty, "shjssj jshds jhdsd sj");
      qty = qty && !isNaN(qty) && qty > 0 ? qty : 1;

      const item = {
        id: variantId,
        quantity: qty,
      };

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
        body: JSON.stringify(item),
      })
        .then(function () {
          update_header_cart();
          window.location.href = "/checkout";
        })
        .catch((error) => console.error("Error:", error));
    });

    function charLimit(str) {
      if (str.length < 255) {
        return true;
      }
      return false;
    }
    function numberLimit(num) {
      if (num.length < 15) {
        return true;
      }
      return false;
    }
    function pincodeLimit(num) {
      if (num.length < 7) {
        return true;
      }
      return false;
    }

    const inputs = document.querySelectorAll('input[type="text"], textarea');

    $("#ContactForm input,#ContactForm textarea").on("input", function () {
      $(this).siblings(".error-form").hide();
    });

    // inputs.forEach(function (element) {
    //   element.addEventListener("beforeinput", function (event) {
    //     if (event.inputType === "deleteContentBackward") {
    //       return;
    //     }

    //     var value = this.value;
    //     var newValue = value + event.data;

    //     // Regular expression to detect URLs
    //     const urlRegex = /(https?:\/\/[^\s]+)/g;

    //     // Check if the input is an attempt to enter URL-like text or if it's invalid input (non-alpha)
    //     if (urlRegex.test(newValue) || /[^a-zA-Z\s]/.test(event.data)) {
    //       event.preventDefault();
    //     }
    //   });

    //   // Disable pasting URLs
    //   element.addEventListener("paste", function (event) {
    //     const clipboardData = event.clipboardData.getData("text");
    //     if (urlRegex.test(clipboardData)) {
    //       event.preventDefault();
    //     }
    //   });
    // });

    window.addEventListener("load", function () {
      const alphaOnly = document.querySelectorAll(
        "#RegisterForm-FirstName, #RegisterForm-LastName,#AddressFirstNameNew, #AddressLastNameNew, #AddressCityNew, #AddressFirstNameEdit, #AddressLastNameEdit, .AAddressFirstName, .AAddressLastName, .AAddressCity, .contact__fields .name-input, #ContactForm .name-input",
      );
      alphaOnly.forEach(function (element) {
        element.addEventListener("beforeinput", function (event) {
          if (event.inputType === "deleteContentBackward") {
            return;
          }
          var value = this.value;
          if (
            !/^[a-zA-Z ]$/.test(event.data) ||
            (event.data === " " && value.length === 0)
          ) {
            event.preventDefault();
          }
        });
      });

      const addressFields = document.querySelectorAll(
        ".companyField, #AddressAddress1New",
      );

      addressFields.forEach(function (element) {
        element.addEventListener("beforeinput", function (event) {
          if (event.inputType === "deleteContentBackward") return;

          const value = this.value;
          if (
            !/^[a-zA-Z0-9 ,.\-]$/.test(event.data) ||
            (event.data === " " && value.length === 0)
          ) {
            event.preventDefault();
          }
        });
      });

      const numericOnly = document.querySelectorAll(".val-contact");
      numericOnly.forEach(function (element) {
        element.addEventListener("beforeinput", function (event) {
          const value = element.value;
          console.log("event", event, "value", value);

          // Allow backspace key
          if (event.inputType === "deleteContentBackward") {
            return;
          }

          // If input is not a number or current input is longer than 15, prevent input
          if (!/^\d$/.test(event.data) || value.length >= 15) {
            event.preventDefault();
            return;
          }

          // Ensure the first digit is greater than 5
          if (value.length === 0 && parseInt(event.data) <= 5) {
            event.preventDefault();
          }
        });
      });
    });

    function isValidEmail(email) {
      // Regular expression for a simple email validation
      var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    }

    var $form = $("#ContactForm");
    var $formClone = $form.clone(true);
    $form.replaceWith($formClone);

    $("form[action='/contact#ContactForm']").submit(function (e) {
      e.stopPropagation();
      e.preventDefault();
      $(".error-form").remove();
      var FirstName = $("#ContactForm-name").val();
      var Contact = $("#ContactForm-phone").val();
      var Email = $("#ContactForm-email").val();
      var Enquiry = $("#ContactForm-body").val();

      if (FirstName == "") {
        $("#ContactForm-name")
          .closest(".field")
          .append('<div class="error-form">Please enter name</div>');
      } else {
        if (!charLimit(FirstName)) {
          $("#ContactForm-name")
            .closest(".field")
            .append('<div class="error-form">Please enter valid name</div>');
        }
      }
      if (Contact == "") {
        $("#ContactForm-phone")
          .closest(".field")
          .append('<div class="error-form">Please enter contact no.</div>');
      }
      if (Email == "") {
        $("#ContactForm-email")
          .closest(".field")
          .append('<div class="error-form">Please enter email</div>');
      } else {
        if (!isValidEmail(Email)) {
          $("#ContactForm-email")
            .closest(".field")
            .append('<div class="error-form">Please enter valid email</div>');
        }
        if (!charLimit(Email)) {
          $("#ContactForm-email")
            .closest(".field")
            .append('<div class="error-form">Please enter valid email</div>');
        }
      }
      if (Enquiry == "") {
        $("#ContactForm-body")
          .closest(".field")
          .append('<div class="error-form">Please enter enquiry</div>');
      }

      if (
        FirstName != "" &&
        Contact != "" &&
        Email != "" &&
        Enquiry != "" &&
        isValidEmail(Email) &&
        charLimit(FirstName) &&
        charLimit(Email)
      ) {
        console.log("in submit");
        //this.submit();

        var $form = $("#ContactForm");
        //console.log($form.serialize());
        jQuery.ajax({
          type: "POST",
          async: true,
          url: "/contact",
          data: $form.serialize(),
          beforeSend: function () {
            $form.addClass("sending");
          },
          error: function (responseerror) {
            if (responseerror.status == 429) {
              //console.log("inside the status");
              // var challengeUrl = window.location.origin + "/challenge#ContactForm";
              // window.location = challengeUrl;
              $(".form__too .many-request").show();
              e.preventDefault();
              return false;
            }
            $form.addClass("error");
          },
          success: function (response) {
            //your success message
            //window.location = window.location.origin+"/pages/contact?contact_posted=true#contact_form";
            $(".form__too .success-request").show();
            $("#ContactForm input,#ContactForm textarea").val("");
          },
        });
      } else {
        e.preventDefault();
        return false;
      }
    });

    // Login Page Css Start

    $(
      'input[type="password"],#CustomerEmail, #CustomerPassword, #RegisterForm-email,#RecoverEmail',
    ).on("cut copy paste", function (e) {
      e.preventDefault();
    });

    $("form[action='/account/login']").submit(function (e) {
      e.preventDefault();
      //$(".error-message").remove();
      $(".error-form").remove();
      var email = $("#CustomerEmail").val();
      var password = $("#CustomerPassword").val();
      if (email == "") {
        //$(".h_wizard").append('<div class="error-message">Please enter email</div>');
        $("#CustomerEmail")
          .closest(".field")
          .append('<div class="error-form">Please enter email</div>');
      } else {
        if (!isValidEmail(email)) {
          //$(".h_wizard").append('<div class="error-message">Please enter valid email</div>');
          $("#CustomerEmail")
            .closest(".field")
            .append('<div class="error-form">Please enter valid email</div>');
        }
      }
      if (password == "") {
        //$(".h_wizard").append('<div class="error-message">Please enter password</div>');
        $("#CustomerPassword")
          .closest(".field")
          .append('<div class="error-form">Please enter password</div>');
      }
      if (email != "" && password != "" && isValidEmail(email)) {
        this.submit();
      }
    });

    $("form[action='/account']").submit(function (e) {
      e.preventDefault();
      $(".error-form").remove();
      var FirstName = $("#RegisterForm-FirstName").val();
      var LastName = $("#RegisterForm-LastName").val();
      var Accountemail = $("#RegisterForm-email").val();
      var AccountPassword = $("#RegisterForm-password").val();
      if (FirstName == "") {
        $("#RegisterForm-FirstName")
          .closest(".field")
          .append('<div class="error-form">Please enter first name</div>');
      }
      if (LastName == "") {
        $("#RegisterForm-LastName")
          .closest(".field")
          .append('<div class="error-form">Please enter last name</div>');
      }
      if (Accountemail == "") {
        $("#RegisterForm-email")
          .closest(".field")
          .append('<div class="error-form">Please enter valid email</div>');
      } else {
        if (!isValidEmail(Accountemail)) {
          $("#RegisterForm-email")
            .closest(".field")
            .append('<div class="error-form">Please enter valid email</div>');
        }
      }
      if (AccountPassword == "") {
        $("#RegisterForm-password")
          .closest(".field")
          .append('<div class="error-form">Please enter password</div>');
      }

      if (
        FirstName != "" &&
        LastName != "" &&
        Accountemail != "" &&
        AccountPassword != "" &&
        isValidEmail(Accountemail)
      ) {
        this.submit();
      }
    });
    //FAQ section according
    $(".question-box").click(function () {
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
      } else {
        $(".question-box").removeClass("active");
        $(this).addClass("active");
      }
    });

    $("form[action='/account/recover']").submit(function (e) {
      e.preventDefault();
      $(".error-form").remove();
      var recoveremail = $("#RecoverEmail").val();
      if (recoveremail == "") {
        $("#RecoverEmail")
          .closest(".field")
          .append('<div class="error-form">Please enter valid email</div>');
      } else {
        if (!isValidEmail(recoveremail)) {
          $("#RecoverEmail")
            .closest(".field")
            .append('<div class="error-form">Please enter valid email</div>');
        }
      }
      if (recoveremail != "" && isValidEmail(recoveremail)) {
        this.submit();
      }
    });

    $(document).on("submit", "form[action='/account/addresses']", function (e) {
      e.preventDefault();
      $(".error-form").remove();
      let FirstName = $("#AddressFirstNameNew").val();
      let Address = $("#AddressAddress1New").val();
      let City = $("#AddressCityNew").val();
      let Pincode = $("#AddressZipNew").val();
      let Phone = $("#AddressPhoneNew").val();
      if (FirstName == "") {
        $("#AddressFirstNameNew")
          .closest(".field")
          .append('<div class="error-form">Please enter first name</div>');
      } else {
        if (!charLimit(FirstName)) {
          $("#AddressFirstNameNew")
            .closest(".field")
            .append('<div class="error-form">Please enter valid name</div>');
          return false;
        }
      }
      if (Address == "") {
        $("#AddressAddress1New")
          .closest(".field")
          .append('<div class="error-form">Please enter address</div>');
      }
      if (City == "") {
        $("#AddressCityNew")
          .closest(".field")
          .append('<div class="error-form">Please enter city name</div>');
      } else {
        if (!charLimit(City)) {
          $("#AddressCityNew")
            .closest(".field")
            .append(
              '<div class="error-form">Please enter valid city name</div>',
            );
          return false;
        }
      }
      if (Pincode == "") {
        $("#AddressZipNew")
          .closest(".field")
          .append('<div class="error-form">Please enter pincode</div>');
      } else {
        if (!pincodeLimit(Pincode)) {
          $("#AddressZipNew")
            .closest(".field")
            .append('<div class="error-form">Please enter valid pincode</div>');
          return false;
        }
      }
      if (Phone == "") {
        $("#AddressPhoneNew")
          .closest(".field")
          .append('<div class="error-form">Please enter contact no.</div>');
      } else {
        if (!numberLimit(Phone)) {
          $("#AddressPhoneNew")
            .closest(".field")
            .append(
              '<div class="error-form">Please enter valid contact no.</div>',
            );
          return false;
        }
      }

      if (
        FirstName != "" &&
        Address != "" &&
        City != "" &&
        Pincode != "" &&
        Phone != ""
      ) {
        this.submit();
      }
    });

    $(document).on("submit", ".editadress form", function (e) {
      console.log("editform issue");
      e.preventDefault();
      $(".error-form").remove();
      let FirstName = $(this).find(".firstName").val();
      var Address = $(this).find(".address1").val();
      var City = $(this).find(".city").val();
      var Pincode = $(this).find(".pincode").val();
      var Phone = $(this).find(".contact").val();
      console.log(FirstName);
      if (FirstName == "") {
        $(this)
          .find(".firstName")
          .closest(".field")
          .append('<div class="error-form">Please enter first name</div>');
      } else {
        if (!charLimit(FirstName)) {
          $(this)
            .find(".firstName")
            .closest(".field")
            .append('<div class="error-form">Please enter valid name</div>');
          return false;
        }
      }

      if (Address == "") {
        $(this)
          .find(".address1")
          .closest(".field")
          .append('<div class="error-form">Please enter address</div>');
      }
      if (City == "") {
        $(this)
          .find(".city")
          .closest(".field")
          .append('<div class="error-form">Please enter city name</div>');
      } else {
        if (!charLimit(City)) {
          $(this)
            .find(".city")
            .closest(".field")
            .append(
              '<div class="error-form">Please enter valid city name</div>',
            );
          return false;
        }
      }
      if (Pincode == "") {
        $(this)
          .find(".pincode")
          .closest(".field")
          .append('<div class="error-form">Please enter pincode</div>');
      } else {
        if (!pincodeLimit(Pincode)) {
          $(this)
            .find(".pincode")
            .closest(".field")
            .append('<div class="error-form">Please enter valid pincode</div>');
          return false;
        }
      }
      if (Phone == "") {
        $(this)
          .find(".contact")
          .closest(".field")
          .append('<div class="error-form">Please enter contact no.</div>');
      } else {
        if (!numberLimit(Phone)) {
          $(this)
            .find(".contact")
            .closest(".field")
            .append(
              '<div class="error-form">Please enter valid contact no.</div>',
            );
          return false;
        }
      }

      if (
        FirstName != "" &&
        Address != "" &&
        City != "" &&
        Pincode != "" &&
        Phone != ""
      ) {
        this.submit();
      }
    });

    // search functionality
    $(".main-header .search").click(function (e) {
      e.preventDefault();

      $("body").css("overflow", "hidden");

      // Show the overlay
      $(".search-overlay").fadeIn();
      $(".search-container").fadeIn().addClass("active");

      $(".search-container input").focus();

      // hide hamburger menu
      $(".main-header .hamburger").removeClass("is-active");
      $(".header-nav").removeClass("slide-in");
    });

    $(".search-container .search-close-cta").click(function (e) {
      e.preventDefault();
      $("body").css("overflow", "unset");
      // Hide the overlay
      $(".search-overlay").fadeOut();
      $(".search-container").fadeOut().addClass("active");
    });
    // 1) ENTER on keyboard (desktop + mobile)
    $(".search-container input").on("keydown", function (e) {
      if (e.keyCode === 13) {
        e.preventDefault();
        $(this).closest("form").submit();
      }
    });

    // 2) Form submit
    $("form[action='/search']").on("submit", function (e) {
      e.preventDefault();
      let searchQuery = $(this).find("input").val().trim();
      window.location = `/search?q=${searchQuery}&type=product`;
    });
  });

  // Contact us modal popup code below
  $(document).on("click", ".contact-us-modal", function (e) {
    e.preventDefault();
    $("#contact-modal").fadeIn();
    $("body").css("overflow", "hidden");
  });

  $(document).on("click", ".modal-close, .modal-overlay", function () {
    $("#contact-modal").fadeOut();
    $("body").css("overflow", "auto");
  });

  $(document).on("click", ".modal-content", function (e) {
    e.stopPropagation();
  });

  // contact form

  document.addEventListener("DOMContentLoaded", function () {
    const form = document.querySelector('form[action*="contact"]');
    if (!form) return;

    // INPUT REFERENCES
    const nameInput = document.getElementById("contact_name");
    const emailInput = document.getElementById("contact_email");
    const phoneInput = document.getElementById("contact_phone");
    const waInput = document.getElementById("contact_wa");
    const messageInput = document.getElementById("contact_message");
    const submitBtn = form.querySelector(".submit-btn");

    // FIX: Make them NULL if not present to avoid error
    const boardSelect = document.getElementById("contact_board") || null;
    const classSelect = document.getElementById("contact_class") || null;

    // DISABLE COPY / PASTE
    [nameInput, emailInput, phoneInput, waInput, messageInput].forEach(
      (input) => {
        if (input) {
          ["paste", "copy"].forEach((evt) =>
            input.addEventListener(evt, (e) => e.preventDefault()),
          );
        }
      },
    );

    // PHONE VALIDATION 10 DIGITS
    if (phoneInput) {
      phoneInput.addEventListener("input", function () {
        this.value = this.value.replace(/[^0-9]/g, "").slice(0, 10);
      });
    }

    if (waInput) {
      waInput.addEventListener("input", function () {
        this.value = this.value.replace(/[^0-9]/g, "").slice(0, 10);
      });
    }

    // NAME VALIDATION
    if (nameInput) {
      nameInput.addEventListener("input", function () {
        this.value = this.value.replace(/[^a-zA-Z\s]/g, "").slice(0, 100);
      });
    }

    // EMAIL CHARACTER LIMIT
    if (emailInput) {
      emailInput.addEventListener("input", function () {
        this.value = this.value.slice(0, 100);
      });
    }

    // MESSAGE CHARACTER LIMIT
    if (messageInput) {
      messageInput.addEventListener("input", function () {
        this.value = this.value.slice(0, 100);
      });
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // ---------------- VALIDATION ----------------
    function showError(input, msg) {
      const el = input.closest(".form-group")?.querySelector(".error-text");
      if (el) {
        el.textContent = msg;
        el.style.display = "inline";
      }
      input.classList.add("error");
    }

    function clearErrors() {
      document.querySelectorAll(".error-text").forEach((el) => {
        el.textContent = "";
        el.style.display = "none";
      });
      document
        .querySelectorAll(".error")
        .forEach((el) => el.classList.remove("error"));
    }

    function validateForm() {
      clearErrors();
      let ok = true;

      // ------------------ NAME ------------------
      const nameVal = nameInput.value.trim();
      if (!nameVal) {
        showError(nameInput, "Name is required");
        ok = false;
      } else if (nameVal.length < 3) {
        showError(nameInput, "Name must be at least 3 characters");
        ok = false;
      } else if (!/^[a-zA-Z\s]+$/.test(nameVal)) {
        showError(nameInput, "Name can only contain letters and spaces");
        ok = false;
      }

      // ------------------ EMAIL ------------------
      const emailVal = emailInput.value.trim();
      if (!emailVal) {
        showError(emailInput, "Email is required");
        ok = false;
      } else if (!emailRegex.test(emailVal)) {
        showError(emailInput, "Invalid email address");
        ok = false;
      }

      // ------------------ PHONE ------------------
      const phoneVal = phoneInput.value.trim();
      if (!phoneVal) {
        showError(phoneInput, "Phone number is required");
        ok = false;
      } else if (!/^[6-9]\d{9}$/.test(phoneVal)) {
        showError(phoneInput, "Enter valid 10-digit phone number");
        ok = false;
      }

      // ------------------ WHATSAPP ------------------
      const waVal = waInput.value.trim();
      if (!waVal) {
        showError(waInput, "Whatsapp number is required");
        ok = false;
      } else if (!/^[6-9]\d{9}$/.test(waVal)) {
        showError(waInput, "Enter valid 10-digit Whatsapp number");
        ok = false;
      }

      // ------------------ MESSAGE ------------------
      if (messageInput && messageInput.value.length > 1000) {
        showError(messageInput, "Message must be 1000 characters or less");
        ok = false;
      }

      // OPTIONAL (only validate if exist)
      // if (boardSelect && !boardSelect.value.trim()) {
      //   showError(boardSelect, "Please select a board");
      //   ok = false;
      // }
      // if (classSelect && !classSelect.value.trim()) {
      //   showError(classSelect, "Please select a class");
      //   ok = false;
      // }

      return ok;
    }

    // ---------------- SEND EMAIL VIA SHOPIFY ----------------
    async function sendEmail(formData) {
      try {
        const emailFormData = new FormData();
        emailFormData.append("form_type", "contact");
        emailFormData.append("utf8", "✓");

        emailFormData.append("contact[name]", formData.get("contact[name]"));
        emailFormData.append("contact[email]", formData.get("contact[email]"));
        emailFormData.append("contact[phone]", formData.get("contact[phone]"));

        emailFormData.append(
          "contact[body]",
          `Phone: ${formData.get("contact[phone]")}
WhatsApp: ${formData.get("contact[wa]")}

Message: ${formData.get("contact[body]") || "No message"}`,
        );

        const res = await fetch("/contact", {
          method: "POST",
          body: emailFormData,
          headers: {
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
        });

        return res.ok;
      } catch (err) {
        console.error("Email Error:", err);
        return false;
      }
    }

    // ---------------- SEND TO CRM ----------------
    async function sendToCRM(formData) {
      const payload = {
        form_type: "contact_form",
        utf8: "✓",
        "contact[name]": formData.get("contact[name]"),
        "contact[email]": formData.get("contact[email]"),
        "contact[phone]": formData.get("contact[phone]"),
        "contact[wa]": formData.get("contact[wa]"),
        "contact[body]": formData.get("contact[body]") || "",
      };

      try {
        const res = await fetch(
          "https://n8n.amura.in/webhook/2e5b8a07-424b-4e71-92cc-a206df15b210",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          },
        );
        return res.ok;
      } catch (err) {
        console.error("CRM Error:", err);
        return false;
      }
    }

    // ---------------- CREATE CUSTOMER ----------------

    async function createCustomer(formData) {
      const customerData = new FormData();
      customerData.append("form_type", "customer");
      customerData.append("utf8", "✓");

      // Split name into first & last
      const fullName = formData.get("contact[name]").trim();
      const [firstName, ...lastNameParts] = fullName.split(" ");
      const lastName = lastNameParts.join(" ");

      customerData.append("contact[first_name]", firstName || "");
      customerData.append("contact[last_name]", lastName || "");
      customerData.append("contact[email]", formData.get("contact[email]"));
      // customerData.append("contact[phone]", 918254038057);
      // customerData.append(
      //   "contact[body]",
      //   `WhatsApp: ${formData.get("contact[wa]")}\nMessage: ${
      //     formData.get("contact[body]") || ""
      //   }`
      // );

      try {
        const res = await fetch("/contact", {
          method: "POST",
          body: customerData,
          headers: {
            Accept: "text/html",
            "X-Requested-With": "XMLHttpRequest",
          },
        });

        return { ok: res.ok, status: res.status };
      } catch (err) {
        console.error("Customer creation error:", err);
        return { ok: false, status: 500 };
      }
    }

    // ---------------- SUBMIT HANDLER ----------------
    async function handleSubmit() {
      if (!validateForm()) return;

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.classList.add("disabled");
      }

      const formData = new FormData(form);
      clearErrors();

      const emailOk = await sendEmail(formData);
      const crmOk = await sendToCRM(formData);
      const customerRes = await createCustomer(formData);

      if (customerRes.status === 429) {
        form.innerHTML = `<div class="error-message"><p>Too many requests, please try again later.</p></div>`;
        return;
      }

      if (emailOk) {
        form.innerHTML = `<div class="success-message"><p>Thank you! Your message has been sent.</p></div>`;
      } else {
        form.innerHTML = `<div class="error-message"><p>Email sending failed, please try again.</p></div>`;
      }
    }

    window.validateAndSubmit = handleSubmit;
  });

  $("[data-fancybox='gallery-img']").fancybox({
    afterShow: function (instance, current) {
      const index = current.index;
      $(".main-image").slick("slickGoTo", index);
      $(".thumbnails-container").slick("slickGoTo", index);
    },
    afterClose: function () {
      let currentIndex = $(".main-image").slick("slickCurrentSlide");
      $(".thumbnails-container").slick("slickGoTo", currentIndex);
    },
  });

  //     Do not write your code below. ✋😠
}.call(window, window.jQuery);
